<template>
  <within-input :value="radius" @input="radiusChanged" />
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  emits: ['radiusChange'],
})
class FilterAndSortRadius extends Vue {
  @Prop({ required: true })
  radius: number

  radiusChanged(radius: number) {
    if (radius !== this.radius) {
      this.$emit('radiusChange', radius)
    }
  }
}

export default toNative(FilterAndSortRadius)
</script>
